module.exports = __webpack_public_path__ + "img/hion_logo_positivo.6c799a7b.png";